
import React, {
  useState,
  useEffect,
  createContext,
  useContext,
  useCallback,
} from 'react';
import type { User, AuthContextType, LoginResult } from '../types';
import axios from 'axios';
import {nameserver} from "../config/nameServer"
function AuthProvider(props: React.PropsWithChildren<unknown>) {
  const [user, setUser] = useState<User>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Khi reload trang, lấy user từ localStorage
    const userId = localStorage.getItem("userId");
    const userName = localStorage.getItem("userName");
    const FULL_NAME = localStorage.getItem("fullname");

    if (userId && userName && FULL_NAME) {
      setUser({
        ID: Number(userId),
        USER_NAME: userName,
        FULL_NAME: FULL_NAME,
      });
    }

    setLoading(false);
  }, []);

  const signIn = async (username: string, password: string): Promise<LoginResult> => {
    try {
      const res = await axios.post(`${nameserver}/api/login`, {
        username,
        password,
      });
      console.log('data login: ',res.data);
      

      if (res.data.isOk) {
        const u = res.data.user;
        if(u.CAP == null){
          u.CAP = 1;
        }
        // Lưu localStorage
        localStorage.setItem('userId', u.ID.toString());
        localStorage.setItem('userName', u.USER_NAME);
        localStorage.setItem('fullname', u.FULL_NAME);
        localStorage.setItem("cap", u.CAP);

        setUser(u);
      }

      return res.data;
    } catch (error) {
      return {
        isOk: false,
        message: 'Server error',
      };
    }
  };

  const signOut = useCallback(() => {
    localStorage.clear();
    setUser(undefined);
  }, []);

  return (
    <AuthContext.Provider
      value={{ user, signIn, signOut, loading }}
      {...props}
    />
  );
}

const AuthContext = createContext<AuthContextType>({
  loading: false,
  signIn: async () => ({ isOk: false }),
  signOut: () => {},
});

const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth };
